<template>
  <div class="bg-F2F2F6 bt">
    <div class="bg-FFFFFF p-0-16 p-16-0 fb fb-main-start fb-cross-center mb-12">
      <div class="fb fb-main-between fb-cross-center">
        <div
          class="avatar mr-12 avator-image w-36 h-36"
          :class="userInfo.imgClass"
          v-if="userInfo.imgClass"
        ></div>
        <div
          v-else
          class="w-36 h-36 bg-006AFE bd-radio-9999 font-28 fb fb-main-center fb-cross-center c-FFFFFF mr-12"
        >
          <span>{{
            (userInfo.name || userInfo.memberName || '').slice(0, 2)
          }}</span>
        </div>
      </div>
      <div class="item-flex-1 pl-6 font-34 c-171A1D">
        <div class="lh-24 fb fb-main-start fb-cross-center">
          <span>{{
            filterName(userInfo.name || userInfo.memberName || '', 10)
          }}</span>
          <span
            class="iconfont font-28 ml-4"
            v-if="userInfo.imgClass && +userInfo.sex"
            :style="{
              color: +userInfo.sex === 1 ? '#006AFE' : '#FF4D94'
            }"
            >{{ +userInfo.sex === 1 ? '&#xe685;' : '&#xe686;' }}</span
          >
        </div>
        <div
          class="lh-20 c-171A1D-40 font-28 text-ellipsis"
          style="max-width: 300px"
        >
          {{ +userInfo.userType === 2 ? userInfo.relation : userInfo.deptName }}
        </div>
      </div>
    </div>
    <md-field
      v-model="userInfo.mobile"
      :clearable="true"
      label="手机号"
      type="text"
      class="mb-12"
      placeholder="请输入"
      v-if="!userInfo.imgClass"
    ></md-field>
    <md-list>
      <md-list-item between>
        <md-field
          v-model="typeName"
          :clearable="true"
          label="证件类型"
          @click="openSheet"
          placeholder="请输入"
          type="choose"
        ></md-field>
      </md-list-item>
      <md-list-item between>
        <md-field
          v-model="userInfo.cardNo"
          :clearable="true"
          label="证件号码"
          placeholder="请输入"
          type="text"
        ></md-field>
      </md-list-item>
    </md-list>
    <md-field
      :value="shortCode"
      v-show="shortCode"
      label="家长ID"
      type="text"
      :readOnly="true"
      class="mt-12"
      placeholder="请输入"
    ></md-field>
    <div v-show="accountInfoList.length">
      <div
        class="lh-20 c-171A1D-40 font-28 ml-16 mt-20"
        style="max-width: 300px"
      >
        绑定账号
      </div>
      <div
        class="bg-FFFFFF h-72 mt-8 p-0-16 fb fb-main-between fb-cross-center"
        v-for="item in accountInfoList"
        :key="item.bindId"
      >
        <div class="fb fb-cross-center item-flex-1">
          <img
            class="w-40 h-40 mr-12"
            src="@/assets/images/wechat.png"
            alt="微信"
          />
          <div class="font-34">
            <p>{{ ACCOUNT_TYPE_TEXT[item.tpType] }}</p>
            <p class="c-171A1D-40 text-ellipsis">{{ item.tpName }}</p>
          </div>
        </div>
        <md-button
          type="danger"
          v-if="isCanUnbind"
          :block="false"
          size="small"
          @click="() => cancelBind(item.bindId)"
          >解除绑定</md-button
        >
      </div>
    </div>
    <div class="footer pt-8">
      <md-button @click="updateStaffInfo">保存</md-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import mixin from '@/mixin'
import { mcSetTitle, mcToast } from '@/utils/mcSdkUtils'
import { filterName } from '@/utils/comUtils'
import { ACCOUNT_TYPE_TEXT } from '@/utils/constUtils'

export default {
  name: 'PageFaceAdminTreeForm',
  mixins: [mixin],
  data() {
    return {
      filterName,
      userInfo: this.$route.query,
      actions: [],
      typeName: '',
      ACCOUNT_TYPE_TEXT
    }
  },
  computed: {
    shortCode() {
      const target =
        (this.userInfo.bindTpAccountInfoList || []).find(
          item => item.tpType === 'MOREDIAN'
        ) || {}
      return target.tpId || ''
    },
    accountInfoList() {
      return (this.userInfo.bindTpAccountInfoList || []).filter(
        item => item.tpType !== 'MOREDIAN'
      )
    },
    isCanUnbind() {
      const { deptTpId, tpId } = this.$route.query
      const index = this.classList.findIndex(item => item.tpId === (deptTpId || tpId))
      return index >= 0
    }
  },
  async created() {
    try {
      await this.getStudentIdTypes()
    } catch (error) {}
    // 详情接口再查询一次
    if (this.userInfo.imgClass) {
      this.getSchoolStudentInfo()
    } else {
      this.getSchoolUserInfo()
    }
    if (+this.userInfo.userType === 2) {
      mcSetTitle('家长信息管理')
    } else if (+this.userInfo.userType === 3) {
      mcSetTitle('学生信息管理')
    } else {
      mcSetTitle('教职工信息管理')
    }
  },
  methods: {
    // 解除绑定
    cancelBind(bindId) {
      this.$Dialog({
        type: 'confirm',
        title: '解除绑定',
        content: '解除绑定后，家长将无法登录微信公众号的智慧校园。确认解绑？',
        cancelBtn: {
          color: '#171A1D',
          text: '关闭'
        },
        $events: {
          confirm: () => {
            this.cancelAjax(bindId)
          },
          cancel: () => {}
        }
      }).show()
    },
    cancelAjax(bindId) {
      API.gurdianUnBind({
        bindId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return mcToast({ msg: res.message })
          }
          mcToast({ msg: '解绑成功' })
          // 详情接口再查询一次
          if (this.userInfo.imgClass) {
            this.getSchoolStudentInfo()
          } else {
            this.getSchoolUserInfo()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getStudentIdTypes() {
      return new Promise((resolve, reject) => {
        API.getStudentIdTypes()
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
              return false
            }
            this.actions = res.reduce((_list, item) => {
              return _list.concat({
                name: item.desc,
                id: item.value
              })
            }, [])
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    updateStaffInfo() {
      if (this.userInfo.mobile && !/^1[3-9]\d{9}$/.test(this.userInfo.mobile)) {
        mcToast({ msg: '手机号格式错误' })
        return false
      }

      // 证件类型号码必填
      if (
        this.userInfo.cardType === 1 &&
        this.userInfo.cardNo &&
        !/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.userInfo.cardNo
        )
      ) {
        mcToast({ msg: '身份证号格式错误' })
        return false
      }
      return new Promise((resolve, reject) => {
        API.postUserIdentity({
          ...this.userInfo,
          sandboxId: this.userInfo.sandboxId || null
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              mcToast({ msg: res.message })
              return false
            }
            mcToast({ msg: '操作成功！' })
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    openSheet() {
      let that = this
      this.$ActionSheet({
        title: '证件类型',
        cancelText: '取消',
        actions: this.actions,
        active: this.actions.findIndex(
          item => this.userInfo.cardType === item.id
        ),
        onChoose(item, index) {
          that.userInfo.cardType = item.id
          that.typeName = item.name
        }
      }).show()
    },
    getSchoolUserInfo() {
      return new Promise((resolve, reject) => {
        API.getSchoolUserInfo({
          userType: this.userInfo.userType,
          campusId: this.campusId,
          memberId: this.$route.query.memberId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            for (let key in res) {
              this.$set(this.userInfo, key, res[key])
            }
            // this.userInfo = Object.assign(this.userInfo, res)
            if (!this.userInfo.cardType) {
              this.userInfo.cardType = 1
            } else if (
              !this.actions.filter(item => item.id === this.userInfo.cardType)
                .length
            ) {
              this.userInfo.cardType = 99
            }
            this.typeName =
              (
                this.actions.find(item => this.userInfo.cardType === item.id) ||
                {}
              ).name || ''
            this.$forceUpdate()
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    getSchoolStudentInfo() {
      return new Promise((resolve, reject) => {
        API.getUserStudentInfo({
          userType: this.userInfo.userType,
          campusId: this.campusId,
          studentId: this.$route.query.studentId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            for (let key in res) {
              this.$set(this.userInfo, key, res[key])
            }
            // this.userInfo = Object.assign(this.userInfo, res)
            if (!this.userInfo.cardType) {
              this.userInfo.cardType = 1
            } else if (
              !this.actions.filter(item => item.id === this.userInfo.cardType)
                .length
            ) {
              this.userInfo.cardType = 99
            }
            this.typeName =
              (
                this.actions.find(item => this.userInfo.cardType === item.id) ||
                {}
              ).name || ''
            this.$forceUpdate()
          })
          .catch(err => {
            console.log(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-name {
  background: #006afe;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.bg-F2F2F6 {
  background: #f2f2f6;
}
</style>
